var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 12C1.5 12.8285 2.17157 13.5 3 13.5H4.5V16.3299C4.5 16.977 5.2646 17.3203 5.74827 16.8904L9.5625 13.5H15C15.8285 13.5 16.5 12.8285 16.5 12V3.75C16.5 2.92157 15.8285 2.25 15 2.25H3C2.17157 2.25 1.5 2.92157 1.5 3.75V12ZM5.625 13.5C5.625 12.8787 5.12132 12.375 4.5 12.375H3C2.79289 12.375 2.625 12.2071 2.625 12V3.75C2.625 3.54289 2.79289 3.375 3 3.375H15C15.2071 3.375 15.375 3.54289 15.375 3.75V12C15.375 12.2071 15.2071 12.375 15 12.375H9.5625C9.28695 12.375 9.021 12.4761 8.81512 12.6592L5.625 15.4948V13.5Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComment);
export default __webpack_public_path__ + "static/media/icon_comment.352f4b09315750fa1199ee7eea42c2e8.svg";
export { ForwardRef as ReactComponent };